import styles from "./input.module.css"
import {ReactComponent as FileInput} from "../../assets/svgs/file-input.svg"

interface UploadInputProps{
  fileName: string;
  fileSize : string
  href?: string;
}
const UploadInput: React.FC<UploadInputProps> = ({ fileName, fileSize, href }) => {
  return (
    <section className={styles.uploadInput}>
        <div className={styles.fileDiv}>
          <FileInput />
          
          <div>
            <p className={styles.fileName}>{fileName}</p>
            <p className={styles.fileSize}>{fileSize}</p>
          </div>
        </div>

        <div>
          <a href={href} target="_blank" rel="noopener noreferrer" className={styles.anchor}>Download</a>
        </div>
    </section>
  )
}

export default UploadInput